import { FC } from "react";
import { Control, FieldValues, UseFormRegister, UseFormSetValue } from "react-hook-form";
import classNames from "classnames";

import { Spacer } from "components/organisms/Spacer/Spacer";

import { FiltersLayout, Filter } from "@types";

import { Filters } from "./filters";
import s from "./FiltersForm.module.scss";

interface Props {
  filters: Filter[];
  register: UseFormRegister<FieldValues>;
  control: Control;
  setValue: UseFormSetValue<any>;
  layout?: FiltersLayout;
}

export const FiltersForm: FC<Props> = (props) => {
  return (
    <form className={s.FiltersForm}>
      <fieldset>
        <Spacer size="s">
          <div
            className={classNames(s.Layout, {
              [s.GridTwoThird]: props.layout === FiltersLayout.GridTwoThird,
              [s.GridOfThree]: props.layout === FiltersLayout.GridOfThree,
            })}
          >
            <Filters {...props} />
          </div>
        </Spacer>
      </fieldset>
    </form>
  );
};
